export function getCookie(name) {
  const value = "; " + document.cookie;
  const parts = value.split("; " + name + "=");
  if (parts.length === 2) return parts.pop().split(";").shift();
  return undefined
}

export function formatDate(date) {
  return moment(date).format("DD.MM.YYYY HH:mm:ss")
}

export function searchItems(items, keys, searchOptions) {
  return items
    .filter(item => {
      return searchOptions.every(keyword => {
        let regex = new RegExp(keyword, "i")
        return keys.some(key => {
          return regex.test(item[key])
        })
      })
    })
}

export function searchData(items, str, searchOptions) {
  return items.filter(item => {
    if (!str) return true
    return str.split(" ")
      .filter(item => item)
      .slice(0, 10)
      .every(keyword => {
        if (!keyword) return false
        let regex = new RegExp(escapeStringRegexp(keyword), "i")
        return searchOptions.some(col => {
          return regex.test(item[col])
        })
      })
  })
}

export function filterArrByUniqKey(arr, key) {
  return arr.filter((v, i, a) => a.findIndex(t => (t[key] === v[key])) === i)
}

export function hasObjectKey(obj, keyString) {
  return obj && Object.prototype.hasOwnProperty.call(obj, keyString)
}

export function json2xls(data, name, colNum, fromArray = false) {
  const XLSX = require("xlsx/dist/xlsx.core.min.js")
  const FileSaver = require("file-saver")

  const wb = {
    SheetNames: [],
    Sheets: [],
  }

  let ws
  if (fromArray) {
    ws = XLSX.utils.aoa_to_sheet(data)
  } else {
    ws = XLSX.utils.json_to_sheet(data)
  }
  ws["!cols"] = Array(colNum).fill({wpx: 120});

  const ws_name = "Лист 1"
  /* Add the sheet name to the list */
  wb.SheetNames.push(ws_name);

  /* Load the worksheet object */
  wb.Sheets[ws_name] = ws;

  // let workbook = XLSX.utils.json_to_sheet(data)

  /* bookType can be any supported output type */
  const wopts = {bookType: "xlsx", bookSST: false, type: "binary"};

  const wbout = XLSX.write(wb, wopts);

  function s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }

  /* the saveAs call downloads a file on the local machine */
  const blob = new Blob([s2ab(wbout)], {type: "application/octet-stream"})
  FileSaver.saveAs(blob, name + ".xlsx");
}

import moment from "moment"
import {store} from "@/store";

export function deepClone(item) {
  if (Array.isArray(item)) {
    // todo mnogo vremeni zanimaet, nujno proverit kak rabotaet
    return [...item.map(i => {
      if (Array.isArray(i)) {
        return [...i]
      }
      // else if (typeof i === "object") {
      //   return {...i}
      // }
      return i
    })]
    // return item.map(i => deepClone(i))
  } else if (Object.prototype.toString.call(item) === "[object Date]") {
    return new Date(item)
  } else if (Object.prototype.toString.call(item) === "[object RegExp]") {
    return new RegExp(item)
  } else if (Object.prototype.toString.call(item) === "[object Function]") {
    return function newFunc() {return item.apply(this, arguments)}
  } else if (item instanceof moment) {
    return item.clone()
  } else if (Object.prototype.toString.call(item) === "[object Object]") {
    let obj = {}
    Object.keys(item).forEach(key => {
      obj[key] = deepClone(item[key])
    })
    return obj
  }
  return item
}

export function escapeStringRegexp(str) {
  let matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
  if (typeof str !== "string") {
    throw new TypeError("Expected a string");
  }
  return str.replace(matchOperatorsRe, "\\$&");
}

export function uniq(arr, key = "id", withoutSort = false) {
  if (!Array.isArray(arr)) {
    throw new TypeError("Expected array as a first argument");
  }
  if (typeof key !== "string") {
    throw new TypeError("Expected string as a second argument");
  }
  let ids = arr.map(a => a[key])
  let uniqArr = arr
    .filter((value, index) => ids.indexOf(value[key]) === index)

  if (!withoutSort) {
    uniqArr = uniqArr.sort((a, b) => {
      if (typeof a[key] !== "string") {
        return a[key] - b[key]
      } else {
        return a[key].localeCompare(b[key])
      }
    })
  }
  return uniqArr
}

export function capitalize(str) {
  if (typeof str !== "string") {
    throw new TypeError("Expected string as a first argument");
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function findBy(items = [], key = "", value, strict = false) {
  if (!Array.isArray(items)) {
    throw new TypeError("Expected array as a first argument");
  }
  if (typeof key !== "string") {
    throw new TypeError("Expected string as a second argument");
  }
  if (typeof strict !== "boolean") {
    throw new TypeError("Expected boolean as a last argument");
  }
  if (strict) {
    if (key) {
      return items.find(item => item[key] === value)
    } else {
      return items.find(item => item === value)
    }
  } else {
    if (key) {
      return items.find(item => item[key] === value)
    } else {
      return items.find(item => item === value)
    }
  }
}

export function findByAndExtract(items, key, value, extractKey, strict = false) {
  if (typeof extractKey !== "string") {
    throw new TypeError("Expected string as a fourth argument");
  }
  let item = findBy(items, key, value, strict)
  return extract(item, extractKey)
}

export function extract(item, key) {
  return item && item[key]
}

export function downloadHref(path, filename = "") {
  if (typeof path !== "string") {
    throw new TypeError("Expected string as a first argument")
  }
  if (typeof filename !== "string") {
    throw new TypeError("Expected string as a second argument")
  }
  let link = document.createElement("a")
  link.href = path
  link.download = filename
  link.click()
}

export function correctDateStart(date) {
  if (!(date instanceof moment)) {
    throw new TypeError("Expected moment as a first argument")
  }
  let contextYear = store.getters["Contexts/getContexts"].year
  let currentYear = moment().year()
  let startOfContextYear = moment().set({"year": contextYear}).startOf("year")
  if  (currentYear > contextYear) {
    return startOfContextYear
  } else {
    return moment.max(startOfContextYear, date)
  }
}

export function correctDateEnd(date) {
  if (!(date instanceof moment)) {
    throw new TypeError("Expected moment as a first argument")
  }
  let contextYear = store.getters["Contexts/getContexts"].year
  let currentYear = moment().year()
  let endOfContextYear = moment().set({"year": contextYear}).endOf("year")
  if  (currentYear > contextYear) {
    return endOfContextYear
  } else {
    return moment.min(endOfContextYear, date)
  }
}

export function convertSecondsToString(duration) {
  if (typeof duration !== "number") {
    throw new TypeError("Expected number as a first argument")
  }
  let durationObj = moment.duration(duration, "seconds")
  let years = durationObj.get("years")
  let months = durationObj.get("months")
  let days = durationObj.get("days")
  let hours = durationObj.get("hours")
  let minutes = durationObj.get("minutes")
  let seconds = durationObj.get("seconds")
  return [
    years ? `${years}г` : "",
    months ? `${months}мес` : "",
    days ? `${days}д` : "",
    hours ? `${hours}ч` : "",
    minutes ? `${minutes}м` : "",
    seconds ? `${seconds}с` : "",
  ].join(" ")
}

export function numberFormatter(value) {
  if (typeof value === "number") {
    const format = new Intl.NumberFormat("ru");
    return format.format(value);
  } else {
    return value
  }
}

export function formatStrInterpolation(str, params) {
  const names = Object.keys(params)
  const vals = Object.values(params)
  return new Function(...names, `return \`${str}\`;`)(...vals)
}

export function countDigitsForStep(val) {
  if (val) {
    let a = val.toString().split(".")
    let b = a[1] ? a[1].length : 0
    let c = "0"
    if (b && b > 0) {
      c += "."
      for (let i = 0; i < b - 1; i++) {
        c += "0"
      }
      c += "1"
    } else {
      c = "1"
    }
    return +c
  } else {
    return 1
  }
}

export function numberDelimeter(val) {
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function diffBetweenDate(date1, date2, precise = false) {
  const difference = moment(date1).diff(moment(date2), 'days', true)
  return precise ? Math.ceil(difference) : Math.floor(difference)
}

export function getSelectInitFilter(key, items = [], isArray, idKey = "id") {
  console.log(key, items, isArray, idKey)
  let result
  let initFilter = JSON.parse(localStorage.getItem("initFilter"))
  let localStorageFilter = initFilter ? initFilter[key] : null

  if (localStorageFilter) {
    if (isArray) {
      if (items.some(a => localStorageFilter.includes(a[idKey]))) {
        result = localStorageFilter
      }
    }
    else {
      if (items.find(i => i[idKey] === localStorageFilter)) {
        result = localStorageFilter
      }
    }
  }
  if (!result && items.length > 0) {
    if (isArray) {
      result = [items[0][idKey]]
    }
    else {
      result = items[0][idKey]
    }
  }
  console.log(result)

  return result
}

export function actionSelectInitFilter(key, value) {
  let initFilter = JSON.parse(localStorage.getItem("initFilter"))
  initFilter = initFilter ? initFilter : {}
  if (key === "warehouseIds" && value.length > 0) {
    initFilter.warehouseId = value[0]
  }
  else if (key === "warehouseId" && value) {
    initFilter.warehouseIds = [value]
  }
  if (initFilter && typeof initFilter === "object") {
    initFilter[key] = value
    localStorage.setItem("initFilter", JSON.stringify(initFilter))
  } else {
    initFilter = {}
    initFilter[key] = value
    localStorage.setItem("initFilter", JSON.stringify(initFilter))
  }
}



export function findDict(items = {}, value, key) {
  let item = items[value]
  item = item ? item : {}
  if (key) {
    return item[key]
  }
  return item
}


export function getFieldScoreNumber(item) {
  let fieldScore = 0
  if (item.fieldScorePercent >= 130) fieldScore = 5
  else if (item.fieldScorePercent >= 110) fieldScore = 4
  else if (item.fieldScorePercent >= 90) fieldScore = 3
  else if (item.fieldScorePercent >= 70) fieldScore = 2
  else if (item.fieldScorePercent > 0) fieldScore = 1

  return fieldScore
}
